import React from 'react';
import TextField from '@mui/material/TextField';
import { stripEmoji, stripLeadingSpecialChars } from '../../../utils/formatting';

const CommonTextField = ({ value, onChange, leftElement, readOnly, readOnlyAmend, className, placeholder, type, maxLength, disabled, InputProps, key, defaultValue, min }) => {
    const contractStatus = sessionStorage.getItem('Selected Contract Status');
    const isReadOnlyOrDisabled = contractStatus === "ACTIVE" || readOnlyAmend || disabled || readOnly;

    const handleWheel = (e) => {
        e.target.blur();
    };

    const handleChange = (e) => {
        const rawVal = e.target.value;
        const cleaned = stripLeadingSpecialChars(stripEmoji(rawVal));
        if (cleaned !== rawVal) {
            e.target.value = cleaned;
        }
        onChange?.(e);
    };

    const handleKeyDown = (e) => {
        if (type === 'number' || type === 'tel') {
            if (["e", "E", "+", "-"].includes(e.key)) {
                e.preventDefault();
            }
            if (e.key === 'ArrowDown' && (isNaN(parseFloat(value)) || parseFloat(value) <= 0)) {
                e.preventDefault();
            }
        }
    };

    return (
        <TextField
            sx={{
                '& .MuiOutlinedInput-root': {
                    backgroundColor: (contractStatus === "ACTIVE" || disabled) ? '#f5f5f5' : undefined,
                    cursor: isReadOnlyOrDisabled ? 'default' : undefined,
                },
            }}
            size="small"
            placeholder={placeholder}
            type={type}
            maxLength={maxLength}
            min={min}
            disabled={(contractStatus === "ACTIVE" || readOnlyAmend) ? true : disabled}
            InputProps={InputProps}
            onChange={handleChange}
            value={value}
            leftElement={leftElement}
            inputProps={{
                style: {
                    height: 15,
                    cursor: isReadOnlyOrDisabled ? 'default' : undefined,
                },
            }}
            className={className}
            readOnly={readOnly}
            key={key}
            defaultValue={defaultValue}
            onKeyDown={handleKeyDown}
            onWheel={type === 'number' ? handleWheel : undefined}
        />
    )
}

export default CommonTextField;